var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8125 0C22.1262 0 24.8125 2.68629 24.8125 6V18C24.8125 21.3137 22.1262 24 18.8125 24H6.8125C3.49879 24 0.8125 21.3137 0.8125 18V6C0.8125 2.68629 3.49879 0 6.8125 0H18.8125Z",
    fill: "#F5D204"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93358 10.1426H3.1397L3.13379 8.24219H13.1012V10.1426H8.83346V17.7422H6.93358V10.1426Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1132 13.9424H12.2886V12.0425H18.3049C19.36 12.0425 19.8881 11.7259 19.8881 11.092C19.8881 10.4582 19.3606 10.1421 18.3049 10.1421H12.2886V8.24219H18.6215C20.7324 8.24219 21.788 9.19213 21.788 11.092C21.788 12.9919 20.7324 13.9419 18.6215 13.9419H18.0328L22.4911 17.7416H19.5715L15.1132 13.9419V13.9424Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrentIcon);
export default __webpack_public_path__ + "static/media/trent-icon.62a888db3602fc4d3e8b7bd00b2bfc16.svg";
export { ForwardRef as ReactComponent };